// Der Rück-Link zum Entwicklungsportal (SPEC-003).
//
// Der Wert kommt aus der Einstellungs-Tabelle und ist vom Admin
// veränderbar — also nichts, worauf sich die Oberfläche blind verlassen
// darf. Genau das war der Fehler hinter dem Befund „Zurück führt auf
// eine 404-Seite": die Adresse wurde ungeprüft an
// `window.location.assign()` gereicht.
//
// Zwei Dinge gehen dabei schief:
//
//   1. Ein Wert ohne Schema („portal.buch-engel.com") ist für
//      `assign()` ein RELATIVER Pfad. Der Browser springt auf
//      /portal.buch-engel.com, der ServiceWorker beantwortet die
//      Navigation mit der index.html, und der Router zeigt seine
//      Nicht-gefunden-Ansicht. Eine hausgemachte 404.
//   2. Ein leerer Wert lädt die aktuelle Seite neu — ein Knopf, der
//      scheinbar nichts tut.
//
// Deshalb hier eine Prüfung, die nur durchlässt, was wirklich eine
// auswärtige Adresse ist. Alles andere blendet den Eintrag aus: kein
// Link ist besser als einer ins Leere.

/**
 * Liefert die Portal-Adresse zurück, wenn sie brauchbar ist — sonst null.
 *
 * Brauchbar heisst: absolute Adresse mit http oder https. Andere Schemata
 * (`javascript:`, `data:`) werden abgewiesen, auch wenn sie technisch
 * absolut sind.
 */
export function portalAdresse(roh: string | null | undefined): string | null {
  if (typeof roh !== 'string') return null;
  const wert = roh.trim();
  if (wert === '') return null;
  let url: URL;
  try {
    // Ohne Basis: eine relative Angabe wirft hier, statt still zu einer
    // App-internen Route zu werden.
    url = new URL(wert);
  } catch {
    return null;
  }
  if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
  // Den Wert des Admins zurueckgeben, nicht die normalisierte Fassung von
  // URL.toString() — die haengt einen Schraegstrich an und aendert damit
  // etwas, das hier nur geprueft werden sollte.
  return wert;
}
